import ApiService from './apiService';
import { IntegrationSettings } from '../models/integrationSettings';
import { mapFrontendToBackendType } from '../utils/integrationTypeMapping';
import { IntegrationType } from '../models/enums/integrationEnums';

class IntegrationSettingsService extends ApiService {
  private static instance?: IntegrationSettingsService;

  private constructor() {
    super();
  }

  static getInstance() {
    if (!IntegrationSettingsService.instance) {
      IntegrationSettingsService.instance = new IntegrationSettingsService();
    }
    return IntegrationSettingsService.instance;
  }

  getAll(): Promise<IntegrationSettings[]> {
    return this.client
      .get(`/configuration/integration-settings?includeIntegrationData=true`)
      .then((response) => response.data);
  }

  getByType(type: string): Promise<IntegrationSettings[]> {
    const backendType = mapFrontendToBackendType(type as IntegrationType);
    return this.client
      .get(`/configuration/integration-settings/types/${backendType}?includeIntegrationData=true`)
      .then((response) => response.data);
  }

  get(id: string): Promise<IntegrationSettings> {
    return this.client.get(`/configuration/integration-settings/${id}`).then((response) => response.data);
  }

  create(settings: IntegrationSettings): Promise<void> {
    return this.client.post(`/configuration/integration-settings`, settings);
  }

  update(settings: IntegrationSettings): Promise<void> {
    return this.client.patch(`/configuration/integration-settings/${settings.integrationSettingsId}`, settings);
  }

  delete(id: number): Promise<void> {
    return this.client.delete(`/configuration/integration-settings/${id}`);
  }

  getVendorTypeMappings(): Promise<any> {
    return this.client.get(`/configuration/integration-settings/types-vendors`).then((response) => response.data);
  }
}

export default IntegrationSettingsService;
